import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => createStyles({
  icon: {
    height: '8rem',
    [theme.breakpoints.up('md')]: {
      height: '11rem',
    },
  },
  divider: {
    backgroundColor: theme.palette.text.primary,
  },
  price: {
    textDecoration: 'line-through',
  },
  leftColumn: {
    maxWidth: '36rem',
    margin: 'auto',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  rightColumn: {
    [theme.breakpoints.down('sm')]: {
      margin: 'auto',
      maxWidth: '34rem',
    },
  },
  conditionLink: {
    margin: theme.spacing(1, 0),
    [theme.breakpoints.up('md')]: {
      margin: 0,
    },
    display: 'flex',
    cursor: 'pointer',
  },
}))
